/* eslint-disable react/no-array-index-key */
import React, { FunctionComponent, useMemo } from 'react';
import { Container, Content, ImageBox } from './ProductSlideshow.style';

interface ProductSlideshowProps {
  images: string[];
  alts: string[];
  aspectRatio: string;
  activeKey: number;
}

interface StaticImageProps {
  alt: ProductSlideshowProps['alts'][number];
  src: ProductSlideshowProps['images'][number];
  aspectRatio: ProductSlideshowProps['aspectRatio'];
}

export const StaticImage: FunctionComponent<StaticImageProps> = ({ aspectRatio, src, alt }) => (
  <Container aspectRatio={aspectRatio}>
    <Content>
      <ImageBox active data-testid="static-image" src={src} alt={alt} />
    </Content>
  </Container>
);

const ProductSlideshow: FunctionComponent<ProductSlideshowProps> = ({ images, alts, aspectRatio, activeKey }) => {
  const { lastIndex, nextIndex } = useMemo(() => {
    return {
      lastIndex: activeKey - 1 < 0 ? images.length - 1 : activeKey - 1,
      nextIndex: activeKey + 1 >= images.length ? 0 : activeKey + 1,
    };
  }, [activeKey, images.length]);

  return (
    <Container aspectRatio={aspectRatio}>
      <Content>
        <ImageBox
          key={lastIndex}
          active={false}
          data-testid="prev-image"
          src={images[lastIndex]}
          alt={alts[lastIndex]}
        />

        <ImageBox key={activeKey} active data-testid="active-image" src={images[activeKey]} alt={alts[activeKey]} />

        <ImageBox
          key={nextIndex}
          active={false}
          data-testid="next-image"
          src={images[nextIndex]}
          alt={alts[nextIndex]}
        />
      </Content>
    </Container>
  );
};

export default ProductSlideshow;
